import { render, staticRenderFns } from "./ColorModuleRequest.vue?vue&type=template&id=5c62f43e&scoped=true"
import script from "./ColorModuleRequest.vue?vue&type=script&lang=ts"
export * from "./ColorModuleRequest.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleRequest.vue?vue&type=style&index=0&id=5c62f43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62f43e",
  null
  
)

export default component.exports